export default class BlockGallery {
    static init() {
        this.galleries = document.querySelectorAll('.block-gallery');

        if (this.galleries.length > 0) {
            this.galleries.forEach((gallery) => {
                let masonryGallery = gallery.querySelector('.block-gallery-masonry');
                if (masonryGallery) {
                    var msnry = new Masonry(masonryGallery, {
                        percentPosition: true,
                        transitionDuration: 0
                    });
                }
            });
        }
    }
}